import { render, staticRenderFns } from "./js-achieve-dialog.vue?vue&type=template&id=61ec00af&scoped=true"
import script from "./js-achieve-dialog.vue?vue&type=script&lang=js"
export * from "./js-achieve-dialog.vue?vue&type=script&lang=js"
import style0 from "./js-achieve-dialog.vue?vue&type=style&index=0&id=61ec00af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec00af",
  null
  
)

export default component.exports